import React from 'react'
import '../../../components/Navigation/Footer/index.js' // FooterWholesalerElement and onetrust
import { BrComponent } from '@bloomreach/react-sdk'
import FooterNav from './FooterNav.jsx'
import FooterConnectBanner from './FooterConnectBanner.jsx'
import FooterDefaultContent from './FooterDefaultContent.jsx'
import { isInstitutional } from '../../../global/authentication/authentication-manager.js'
import DisclosureLinks from './DisclosureLinks.jsx'
import FooterDisclosure from './FooterDisclosure.jsx'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'
import { SWRConfig } from 'swr'
import { buildBundleUrl, useFetch, sessionStorageProvider } from './services.js'

const FooterLegal = () => {
  return (
    <section className="Footer-legal u-marginTop8gu u-sizeConstrained">
      <DisclosureLinks />
      <BrComponent path="footer-disclosures">
        <FooterDisclosure />
      </BrComponent>
    </section>
  )
}

const Footer = () => {
  const url = buildBundleUrl('cti-advisor.contact-us-mutual-funds')

  const { data, isError, isLoading } = useFetch(url)

  if (isError || isLoading) return <div></div>
  return (
    <>
      <a
        className="Footer-jumpLink u-linkComplex u-hidden u-sm-hidden u-md-hidden"
        href="#contact-us"
        aria-label="Contact Us"
      >
        <span className="Footer-jumpLinkText u-textSizeMsrp2 u-flex u-flexAlignItemsCenter">
          <span className="Icon--material u-textSizeMsrp2 u-marginRight1gu">
            phone_outline
          </span>
          <span className="u-linkComplexTarget hover-underline-animation u-textSecondary u-textSizeMsrp2 u-posRelative">
            {data.bundles.default.title}
          </span>
        </span>
      </a>

      <footer className="Footer u-bgColorWhite u-posRelative">
        <FooterDefaultContent />
        <div
          id="footer-navigation"
          className="u-decoBackgroundLight u-paddingBottom6gu u-sm-paddingBottom0"
          data-analytics-component-name="Footer Navigation"
          data-qa-automation="footer-navigation"
        >
          {!isInstitutional() && <FooterConnectBanner />}
          <BrComponent path="footer-nav">
            <FooterNav />
          </BrComponent>
        </div>
        <FooterLegal />
      </footer>

      <ie-modal></ie-modal>
    </>
  )
}

export default function ErrorWrapperFooter(props) {
  return (
    <ErrorBoundary
      fallback={() =>
        !isProduction() ? <p>Erorr in Footer component</p> : null
      }
    >
      <SWRConfig value={{ provider: sessionStorageProvider }}>
        <Footer {...props}></Footer>
      </SWRConfig>
    </ErrorBoundary>
  )
}
